import { useAppRatingPromptGate } from '../hooks/appRating/useAppRatingPromptGate';

export default function AppInitializers(): null {
  useAppRatingPromptGate();
  return null;
}
